import { useEffect, useState } from "react";
import { Route } from "lucide-react";
import { fmtDate } from "@/lib/api";

const riyadhDay = (offsetDays = 0) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Riyadh" }).format(new Date(Date.now() - offsetDays * 86400000));

export const TODAY = () => riyadhDay(0);

export const TrackPicker = ({ agents, track, onShow, onClear }) => {
  const [agentId, setAgentId] = useState("");
  const [day, setDay] = useState(TODAY());
  useEffect(() => {
    if (track) {
      setAgentId(track.id);
      setDay(track.day);
    }
  }, [track]);
  const field = "w-full border border-slate-200 rounded-lg px-2 py-1.5 text-sm bg-white";
  return (
    <div className={`bg-white border rounded-xl p-4 text-sm space-y-2 ${track ? "border-brand-red/40" : "border-slate-200"}`} data-testid="map-track-panel">
      <p className="font-heading font-bold flex items-center gap-2"><Route size={16} className="text-brand-red" />سجل المسارات</p>
      <select value={agentId} onChange={(e) => setAgentId(e.target.value)} className={field} data-testid="track-agent-select">
        <option value="">اختر المندوب</option>
        {agents.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
      </select>
      <input type="date" value={day} min={riyadhDay(29)} max={TODAY()} onChange={(e) => setDay(e.target.value)} className={field} data-testid="track-date-input" />
      <button disabled={!agentId || !day} onClick={() => onShow(agents.find((a) => a.id === agentId), day)} data-testid="track-show-btn"
        className="w-full rounded-lg bg-brand-navy text-white font-bold py-1.5 disabled:opacity-40 transition-opacity">عرض المسار</button>
      <p className="text-[11px] text-slate-500">تُحفظ المسارات لآخر 30 يوماً.</p>
      {track && (
        <div className="pt-2 border-t border-slate-100" data-testid="track-summary">
          <p className="font-bold">مسار {track.name} · {track.day === TODAY() ? "اليوم" : track.day}</p>
          <p className="text-xs text-slate-500">{track.count} نقطة · من {fmtDate(track.from)} إلى {fmtDate(track.to)}</p>
          <button onClick={onClear} data-testid="map-track-clear" className="mt-1 text-xs underline">إخفاء المسار</button>
        </div>
      )}
    </div>
  );
};
